var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1208_101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.22925 24.1663C3.74591 24.1663 3.323 23.9851 2.9605 23.6226C2.598 23.2601 2.41675 22.8372 2.41675 22.3538V6.64551C2.41675 6.16217 2.598 5.73926 2.9605 5.37676C3.323 5.01426 3.74591 4.83301 4.22925 4.83301H24.7709C25.2542 4.83301 25.6772 5.01426 26.0397 5.37676C26.4022 5.73926 26.5834 6.16217 26.5834 6.64551V22.3538C26.5834 22.8372 26.4022 23.2601 26.0397 23.6226C25.6772 23.9851 25.2542 24.1663 24.7709 24.1663H4.22925ZM24.7709 8.30697L14.9834 14.7111C14.9029 14.7514 14.8273 14.7867 14.7569 14.8169C14.6864 14.8471 14.6008 14.8622 14.5001 14.8622C14.3994 14.8622 14.3138 14.8471 14.2433 14.8169C14.1728 14.7867 14.0973 14.7514 14.0167 14.7111L4.22925 8.30697V22.3538H24.7709V8.30697ZM14.5001 13.2309L24.6501 6.64551H4.38029L14.5001 13.2309ZM4.22925 8.51842V7.3252V7.3403V7.31009V8.51842Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1208_101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.ff48dcbcd8b7a5cec1e2c7e4a122fecd.svg";
export { ForwardRef as ReactComponent };